"use client";

import { IProps, ISession } from "@/models";
import { Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState } from "react";
import Header from "./Header";
import SidebarNav from "./SidebarNav";

type ProfileLayoutClientProps = IProps & {
  session: ISession | null;
};

const ProfileLayoutClient = ({
  children,
  session,
  ...otherProps
}: ProfileLayoutClientProps) => {
  const isMobile = useMediaQuery("(max-width: 991.98px)");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  const handleCloseSidebar = () => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <Box className="content-main bg-light relative" id="jsMain">
      <SidebarNav
        isMobile={isMobile}
        isOpen={isSidebarOpen}
        onNavigate={handleCloseSidebar}
      />

      {isMobile && isSidebarOpen ? (
        <Box
          className="fixed inset-0 bg-black/40 z-[190] closesssss"
          onClick={handleCloseSidebar}
        />
      ) : null}

      <Box className="main-right" pl={isMobile ? 0 : "270px"}>
        <Header
          session={session}
          isMobile={isMobile}
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={handleToggleSidebar}
        />
        <Box {...otherProps}>{children}</Box>
      </Box>
    </Box>
  );
};

export default ProfileLayoutClient;
